export default {
  editor_chatTab_text_messagePlaceholderNamed: 'Enviar mensaje a {peer}',
  editor_chatTab_text_messagePlaceholder_meBot: 'Env\u00edate mensajes',
  mediaTray_chatTab_notification_stickerMessage:
    'ha enviado una sticker: {stickerName}',
};
